import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import NavTitle from '../../../nav-title'
import BtnBack from '../../../btn-back'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import UseOrganization from '../../../../hooks/use-org'
import { useSearchParams } from 'react-router-dom'
import {
  createEjipMemberAPI,
  getEjipMeberByRoundAPI
} from '../../../../services/ejip'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import { BsPlusLg, BsSearch } from 'react-icons/bs'
import Bin from '../../../../images/bin.svg'
import SpinnerLoading from '../../../spinner-loading'
import imgUser from '../../../../images/user.png'
import Autocomplete from '../../../custom/autocomplete'
import ModalCustom from '../../../modal-custom'
import { useDebounce } from '@react-hook/debounce'
import { v4 as uuidv4 } from 'uuid'
import editImg from '../../../../images/Provident-Fund/Edit_Fill.svg'
import MedalEditMember from './medal-edit-member'
import { Controller, useForm } from 'react-hook-form'
import CardCustom from '../../../custom/card-custom'
import CustomAutocomplete from '../../../CustomAutocomplete'
import UseEmpsNameEjip from '../../../../hooks/use-emps-name-ejip'
import InputSearchCustom from '../../../custom/InputSearchCustom'
import { fnDateEn } from '../../../../helper/fnDateEn'

export default function AllMemberRoundsPage() {
  let [searchParams, setSearchParams] = useSearchParams()
  const roundId = searchParams.get('roundId')
  const fundId = searchParams.get('fundId')
  const roundName = searchParams.get('round')

  const [isLoading, setIsLoading] = useState(true)

  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)

  const [percentage, setPercentage] = useState(false)

  const [member, setMember] = useState([])
  const [memberId, setMemberId] = useState({ label: '' })
  const [orgFillter, setOrgFillter] = useState()
  const [org, setOrg] = useState()
  const [isSave, setIsSave] = useState(false)
  const [keyName, setKeyName] = useDebounce('', 1000)
  const dataOrgs = UseOrganization()
  const empName = UseEmpsNameEjip(org?.value, keyName, fundId)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalOpenEditMember, setIsModalOpenEditMember] = useState(false)
  const [search, setSearch] = useDebounce('', 1000)
  const [bodyFilter, setBodyFilter] = useState()
  const handleCancel = () => {
    setIsModalOpen(!isModalOpen)
  }
  useEffect(() => {
    if (dataOrgs.length > 0) {
      setOrg(dataOrgs[0])
    }
  }, [dataOrgs])

  useEffect(() => {
    const body = {
      roundId,
      page: 1,
      orgId: '',
      size: totalLimits,
      search
    }
    fnGetData(body)
  }, [])

  const [data, setData] = useState([])
  const fnGetData = async (body) => {
    try {
      setPage(body.page)
      setBodyFilter(body)
      setIsLoading(true)
      const resp = await getEjipMeberByRoundAPI(body)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setData(resp.result ?? [])
        setTotalRows(resp.totalRows)
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onSubmitAddMember = async (e) => {
    try {
      setIsSave(true)
      const n_member = member.map((d) => {
        return {
          code: d.code,
          orgId: d.orgId,
          per: d.per,
          username: d.username
        }
      })
      const body = {
        roundId,
        member: n_member
      }
      const resp = await createEjipMemberAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        handleCancel()
        const body = {
          roundId,
          page: 1,
          size: totalLimits
        }
        setMember([])
        setMemberId({ label: '' })
        setKeyName('')
        fnGetData(body)
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onSubmitField = async () => {
    const newMember = { ...memberId, id: uuidv4(), per: percentage }
    setMember((prevMembers) => [...prevMembers, newMember])
    setMemberId({ label: '' })
    setKeyName('')
    setPercentage(false)
    setMemberId(false)
  }
  const onDeleteField = async (id) => {
    setMember((prev) => {
      return prev.filter((item) => item.id !== id)
    })
  }
  const [detailById, setdetailById] = useState()
  const showModalEditMember = (d) => {
    setdetailById(d)
    setIsModalOpenEditMember(true)
  }
  const handleCancelEditMember = () => {
    setIsModalOpenEditMember(false)
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      search: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      search: d.search
    }
    setPage(1)
    fnGetData(body)
  }

  return (
    <Row>
      <NavTitle>
        <BtnBack text={roundName} className={'text-muted'} />
      </NavTitle>

      <Col xl={12}>
        <CardCustom className="h-full">
          <div
            className="d-flex gap-3 justify-content-between p-3 "
            style={{ flexWrap: 'wrap' }}
          >
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRows?.toLocaleString()}
            </label>
            <div className="d-flex justify-content-end ">
              <div className="me-3" style={{ minWidth: 150 }}>
                <Autocomplete
                  isClearable={true}
                  placeholder={'All'}
                  options={dataOrgs}
                  value={orgFillter}
                  onChange={(data) => {
                    setOrgFillter(data)
                    const body = {
                      ...bodyFilter,
                      page: 1,
                      orgId: data?.value ?? ''
                    }
                    setPage(1)
                    fnGetData(body)
                  }}
                />
              </div>
              <Form
                className="from-search me-2"
                onSubmit={handleSubmit(onSearch)}
              >
                <Controller
                  name={'search'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch()
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>

              <Button
                // size="sm"
                className="px-4"
                onClick={() => setIsModalOpen(true)}
              >
                <BsPlusLg /> Add Member
              </Button>
            </div>
          </div>
          <Table hover responsive>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table pointer-event">
                <th className="fw-normal">#</th>
                <th className="fw-normal text-center">Image</th>

                <th className="fw-normal">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal text-center">Entry Date</th>
                <th className="fw-normal text-center">Rounds</th>
                <th className="fw-normal text-center">% Deducted</th>
                <th className="fw-normal text-center">Resignation Date</th>
                <th className="fw-normal text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((d, i) => (
                  <tr className="fw-light font-small-2 pointer-event">
                    <td className=" fw-light">
                      {page * totalLimits - totalLimits + i + 1}
                    </td>
                    <td className="text-center fw-light">
                      <Image
                        fluid
                        className="rounded-circle "
                        style={{
                          maxWidth: 40,
                          maxHeight: 40,
                          objectFit: 'cover'
                        }}
                        //src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
                        src={`${d?.img_url}`}
                        onError={(event) => {
                          event.target.src = imgUser
                          event.onerror = null
                        }}
                      />
                    </td>
                    <td className=" fw-light">{d.code}</td>

                    <td className="fw-light">
                      {d.title_th}
                      {d.name_th}
                    </td>
                    <td className="text-center fw-light">
                      {fnDateEn(d.entry_date).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center fw-light">{d.round}</td>
                    <td className="text-center fw-light">{d.percentage}%</td>
                    <td className="text-center fw-light">
                      {d.resignation_date
                        ? fnDateEn(d.resignation_date).format('DD/MM/YYYY')
                        : '-'}
                    </td>
                    <td className="text-center fw-light">
                      <Image
                        src={editImg}
                        onClick={() => showModalEditMember(d)}
                      ></Image>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(p) => {
                const body = {
                  ...bodyFilter,
                  page: p
                }
                fnGetData(body)
                setPage(p)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>
      <ModalCustom
        open={isModalOpen}
        width={700}
        centered
        onCancel={handleCancel}
      >
        <div>
          <h5 className="">
            Add Member <span className="text-primary">{member.length}</span>{' '}
            Peoples
          </h5>
        </div>
        <Form onSubmit={handleSubmit(onSubmitAddMember)}>
          <div className="row border-top">
            <div className="col-xl-12 pt-2">
              <Row>
                <div className="d-flex justify-content-between">
                  <div
                    className="align-self-end d-grid"
                    style={{ minWidth: 120 }}
                  >
                    <div>Org</div>{' '}
                    <Autocomplete
                      options={dataOrgs}
                      value={org}
                      onChange={(data) => {
                        setOrg(data)
                        setMemberId('')
                      }}
                    />
                  </div>
                  <div style={{ minWidth: 330 }}>
                    <div>Name</div>{' '}
                    <CustomAutocomplete
                      placeholder="Name/ Code"
                      options={empName}
                      value={memberId}
                      onChange={(data) => {
                        setMemberId(data)
                      }}
                      onInputChange={(data) => {
                        setKeyName(data ? data.toUpperCase() : '')
                      }}
                      freeSolo={false}
                    />
                  </div>
                  <div
                    className="align-self-end d-grid"
                    style={{ minWidth: 100, maxWidth: 100 }}
                  >
                    <Form.Control
                      type="number"
                      placeholder="%"
                      value={percentage}
                      onChange={(e) => setPercentage(e.target.value)}
                    />
                  </div>
                  <div className="align-self-end d-grid">
                    <Button
                      disabled={percentage < 1 || !percentage || !memberId}
                      className="rounded-3"
                      onClick={onSubmitField}
                      size="sm"
                      style={{ minWidth: 80, maxWidth: 80 }}
                    >
                      <BsPlusLg /> Add
                    </Button>
                  </div>
                </div>
                <div className=" col-12 mt-4 overflow-auto">
                  <Table hover responsive>
                    <tbody>
                      {member.length > 0 ? (
                        member.map((m, i) => (
                          <tr key={i}>
                            <td className="">{m.code}</td>
                            <td className="">{m.fullname}</td>
                            <td className="">{m.per}%</td>
                            <td className="text-center">
                              <Image
                                src={Bin}
                                onClick={() => onDeleteField(m.id)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="font-small-2">
                          <td className="text-center" colSpan={4}>
                            - No Data -
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Row>
            </div>
          </div>

          <div className="col-12 mt-5 mb-3 d-flex gap-3 justify-content-center">
            <Button
              variant="outline-primary rounded-3"
              style={{
                width: '130px'
              }}
              size="sm"
              onClick={handleCancel}
            >
              Cancel
            </Button>

            {member.length > 0 ? (
              <Button
                disabled={isSave}
                className="btn btn-primary rounded-3"
                type="submit"
                style={{
                  width: '130px'
                }}
                size="sm"
              >
                {isSave ? 'Apply...' : 'Apply'}
              </Button>
            ) : (
              <Button
                disabled={true}
                className="btn btn-primary rounded-3"
                type="submit"
                style={{
                  width: '130px'
                }}
                size="sm"
              >
                Apply
              </Button>
            )}
          </div>
        </Form>
      </ModalCustom>
      <MedalEditMember
        isModalOpen={isModalOpenEditMember}
        handleCancel={handleCancelEditMember}
        detail={detailById}
        fundId={fundId}
        fnEffectData={() => {
          fnGetData({ page: 1, ...bodyFilter })
        }}
      />
    </Row>
  )
}
